var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DataModel, Tree } from "@easyquery/core";
import { QueryEx } from "../query/query_ex";
import { lcv } from "../utils/lcv";
var DataModelEx = /** @class */ (function (_super) {
    __extends(DataModelEx, _super);
    function DataModelEx() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataModelEx.prototype.buildQueryPath = function (query) {
        if (lcv.__kt <= 1)
            return _super.prototype.buildQueryPath.call(this, query);
        if (this.mainEntity)
            return _super.prototype.buildQueryPath.call(this, query);
        var entities = this.getEntitiesInQuery(query);
        if (entities.length == 0) {
            throw Error("Cannon build path. Path is empty");
        }
        var tree = new Tree(entities[0]);
        for (var i = 1; i < entities.length; i++) {
            var entity = entities[i];
            if (tree.contains(entity)) {
                continue;
            }
            var path = this.findPath(tree.value, entity);
            if (path != null) {
                //Add path to tree
                tree = this.addPathToTree(tree, (path[0] === tree.value) ? path.slice(1) : path);
            }
            else {
                throw Error("Unable to build query. Cannot build path.");
            }
        }
        tree.setParents();
        return tree;
    };
    DataModelEx.prototype.addPathToTree = function (tree, path) {
        if (path.length == 0) {
            return;
        }
        var pathAdded = false;
        for (var _i = 0, _a = tree.childs; _i < _a.length; _i++) {
            var child = _a[_i];
            if (child.value === path[0]) {
                pathAdded = true;
                if (path.length > 1)
                    child = this.addPathToTree(child, path.slice(1));
                break;
            }
        }
        if (!pathAdded) {
            var link = this.findLink(tree.value, path[0]);
            if (link) {
                var newNode = new Tree(path[0]);
                tree.addChild(newNode);
                if (path.length > 1)
                    newNode = this.addPathToTree(newNode, path.slice(1));
            }
            else if (!tree.parent) {
                var node = new Tree(tree);
                tree = new Tree(path[0]);
                tree.addChild(node);
                if (path.length > 1)
                    tree = this.addPathToTree(tree, path.slice(1));
            }
            else {
                throw Error("Unable to build query. Cannot build path.");
            }
        }
        return tree;
    };
    DataModelEx.prototype.findPath = function (entityFrom, entityTo) {
        var curPath = [];
        var curStep = [];
        var nextStep = [];
        var passedEntities = [];
        var pathFound = false;
        curPath.push(entityFrom);
        curStep.push(curPath);
        passedEntities.push(entityFrom);
        while (!pathFound) {
            nextStep = [];
            for (var _i = 0, curStep_1 = curStep; _i < curStep_1.length; _i++) {
                var path = curStep_1[_i];
                pathFound = this.checkPath(path, entityTo, nextStep, passedEntities);
                if (pathFound) {
                    path.push(entityTo);
                    curPath = path;
                    break;
                }
            }
            curStep = [];
            if (!pathFound) {
                if (nextStep.length == 0)
                    return null;
                //copy nextStep to curStep
                for (var _a = 0, nextStep_1 = nextStep; _a < nextStep_1.length; _a++) {
                    var path = nextStep_1[_a];
                    curStep.push(path);
                }
            }
        }
        return curPath;
    };
    DataModelEx.prototype.checkPath = function (path, entityTo, nextStep, passedEntities) {
        var endPoint = path[path.length - 1];
        var entityLinks = this.getLinksByEntity(endPoint);
        for (var _i = 0, entityLinks_1 = entityLinks; _i < entityLinks_1.length; _i++) {
            var link = entityLinks_1[_i];
            var entity2 = null;
            if (link.entityFrom == endPoint) {
                entity2 = link.entityTo;
            }
            else {
                entity2 = link.entityFrom;
            }
            if (entity2 == entityTo) { //if reach the destination
                nextStep = [];
                return true;
            }
            //if destination is not reached yet we add current node (entity2) to the path and proceed
            if (path.indexOf(entity2) < 0 && passedEntities.indexOf(entity2) < 0) { //to prevent cycling
                passedEntities.push(entity2);
                var newPath = new Array();
                newPath = newPath.concat(path);
                newPath.push(entity2);
                nextStep.push(newPath);
            }
        }
        return false;
    };
    DataModelEx.prototype.createQuery = function () {
        return new QueryEx(this);
    };
    return DataModelEx;
}(DataModel));
export { DataModelEx };
//# sourceMappingURL=model_ex.js.map